import React, { useEffect } from "react";
import ApplicationStatusHistory from "../applications/ApplicationStatusHistory";

const StatusHistoryDialog = ({application, onClose}) => {
    useEffect(() => {
        if (application) {
            // Disable scrolling when dialog opens
            document.body.style.overflow = 'hidden';
            
            // Re-enable scrolling when dialog closes
            return () => {
                document.body.style.overflow = 'auto';
            };
        }
    }, [application]);

    if( application ){
        return (<div 
                className="fixed inset-0 flex items-center justify-center z-[99] bg-black bg-opacity-75"
                onClick={onClose}
            >
                <div 
                className="bg-card rounded-lg shadow-lg p-6 w-[40%] max-md:w-[60%] relative max-h-[90vh] overflow-y-auto"
                onClick={(e) => e.stopPropagation()}
                >
                <h3 className="text-lg font-semibold mb-4">Status History</h3>
                <div className="max-h-[60vh] overflow-y-auto">
                    <ApplicationStatusHistory 
                    applicant={application}
                    />
                </div>
                <div className="flex justify-end mt-4">
                    <button
                    onClick={onClose}
                    className="px-4 py-2 text-sm font-medium text-foreground bg-muted rounded-lg hover:bg-muted"
                    >
                    Close
                    </button>
                </div>
                </div>
            </div>
        )
    }
}

export default StatusHistoryDialog;